// src/App.tsx
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/layout/ProtectedRoute';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SecretaryDashboard from './pages/SecretaryDashboard';
import SupervisorDashboard from './pages/SupervisorDashboard';
import DashboardRedirect from './components/auth/DashboardRedirect';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Routes publiques */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />

          {/* Dashboard général (redirige selon le rôle) */}
          <Route path="/dashboard" element={<DashboardRedirect />} />

          {/* Dashboard secrétaire */}
          <Route path="/secretary/dashboard" element={
            <ProtectedRoute allowedRoles={['secretary']}>
              <SecretaryDashboard />
            </ProtectedRoute>
          } />

          {/* Dashboard superviseur */}
          <Route path="/supervisor/dashboard" element={
            <ProtectedRoute allowedRoles={['supervisor']}>
              <SupervisorDashboard />
            </ProtectedRoute>
          } />

          {/* Route par défaut */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;